import React from "react"
import ThemeProvider from "@material-ui/styles/ThemeProvider"

import Layout from "../../../components/layout"
import SEO from "../../../components/seo"
import SportsTrainingPost from "../../../components/sports-training-post"
import theme from "../../../theme"

const summary = [
  {
    level: "Beginner",
    frequency: "2 to 3 short sessions",
    focus: "Ball control, passing, first touch, movement games",
    weeklyHabit: "Keep touches high and pressure low so confidence grows",
  },
  {
    level: "Developing player",
    frequency: "3 sessions plus a game",
    focus: "Dribbling, receiving, shooting, defending shape, fitness",
    weeklyHabit: "Mix one technical day, one small-sided day, and one match-prep day",
  },
  {
    level: "Competitive player",
    frequency: "3 to 5 sessions plus match",
    focus: "Speed, scanning, position skills, transitions, finishing",
    weeklyHabit: "Review one match moment and turn it into a training goal",
  },
  {
    level: "Advanced player",
    frequency: "5 sessions with recovery",
    focus: "Tactical detail, strength, repeated sprint ability, decision-making",
    weeklyHabit: "Plan recovery as carefully as hard sessions",
  },
]

const sections = [
  {
    title: "Beginner: love the ball first",
    paragraphs: [
      "Early soccer training should be playful and full of ball touches. Use dribbling games, short passing targets, first-touch challenges, and simple shooting practice.",
      "Keep instructions simple. Young players improve quickly when they can try, adjust, and try again without every mistake stopping the session.",
    ],
  },
  {
    title: "Developing player: add structure",
    paragraphs: [
      "A developing player can handle a rhythm of technical work, small-sided games, and match preparation. Sessions should include dribbling, passing, receiving under pressure, shooting, and basic defending.",
      "Short fitness blocks are useful, but most conditioning can come from game-like drills where players still have to make decisions.",
    ],
  },
  {
    title: "Competitive player: train game moments",
    paragraphs: [
      "Competitive players need more specific goals: pressing, transition runs, finishing under pressure, wide play, midfield scanning, or defending one-on-one.",
      "Match review helps. Pick one moment from the weekend and build one training task around it instead of trying to fix everything at once.",
    ],
  },
  {
    title: "Advanced player: balance load and recovery",
    paragraphs: [
      "Advanced soccer training should include tactical work, speed, strength, mobility, position-specific detail, and recovery. Hard sessions should not pile up without easier days between them.",
      "Use a calendar to track training intensity, match days, gym sessions, and rest so fatigue does not quietly become the main opponent.",
    ],
  },
]

const SoccerTrainingRoutines = () => (
  <ThemeProvider theme={theme}>
    <Layout>
      <SEO
        title="Soccer Training Schedule by Skill Level"
        description="Plan soccer training for beginners, developing players, competitive players, and advanced athletes with technical, tactical, fitness, and recovery routines."
      />
      <SportsTrainingPost
        sport="Soccer"
        title="Soccer training routines for different levels"
        intro="A good soccer routine gives players lots of ball contact, clear decisions, match-like pressure, and enough recovery to keep improving."
        sharedCalendarUrl="https://app.schoolcalendar.me/calendar/evil-lionfish-65"
        image="blog-soccer.png"
        imageAlt="Soccer training planning"
        summary={summary}
        sections={sections}
      />
    </Layout>
  </ThemeProvider>
)

export default SoccerTrainingRoutines
